import FolderDescription from './FolderDescription';
import FolderDescriptionContainer, {
  OwnProps,
} from './FolderDescription.container';

export default FolderDescriptionContainer(
  FolderDescription
) as React.ComponentClass<OwnProps>;
